<template>
  <div class="source-connection-details">
    <credentials-details id="open-banking-credentials"
                         v-if="nonObkCredsSupported"
                         :invalid-credentials="invalidCredentials"
                         :source="source"
                         :name-already-used-error="nameAlreadyUsedError"
                         :set-name-already-in-use-error="setNameAlreadyInUseError"
                         :save-credentials-error="saveCredentialsError"
                         :update-mode="updateMode"
                         :on-save="onSave"
                         :show-logo="true">
      <template v-slot:title>
        <div class="title">
          חיבור החשבון לשירות באמצעות
          <span class="bold">פרטי ההתחברות הקבועים</span>
          שלך לאתר {{ source.displayName }}
        </div>
      </template>
    </credentials-details>
    <div v-if="nonObkCredsSupported && openBankingSupported  && !updateMode">
      <div class="separator">
        <div class="line"></div>
        <div class="or">או</div>
        <div class="line"></div>
      </div>
    </div>
    <open-banking-details v-if="openBankingSupported && !updateMode" id="open-banking-credentials-details"
                               :name-already-used-error="nameAlreadyUsedError"
                               :set-name-already-in-use-error="setNameAlreadyInUseError"
                               :validate-name="validateName"
                               :source="source"
                               :show-logo="showOpenBankingLogo"/>
  </div>
</template>

<script>
import OpenBankingDetails from '@/base-components/onboarding/openBanking/OpenBankingDetails';
import CredentialsDetails from '@/base-components/onboarding/CredentialsDetails';
import featureFlag from '@/api/featureFlag';

export default {
  name: 'SourceConnectionDetails',
  components: {
    OpenBankingDetails,
    CredentialsDetails,
  },
  props: {
    source: {
      type: Object,
      required: true,
    },
    onSave: {
      type: Function,
      required: true,
    },
    nameAlreadyUsedError: {
      type: Boolean,
      default: false,
    },
    saveCredentialsError: {
      type: Boolean,
      default: false,
    },
    setNameAlreadyInUseError: {
      type: Function,
    },
    invalidCredentials: {
      type: Boolean,
      default: false,
    },
    showLogo: {
      type: Boolean,
      default: true,
    },
    validateName: {
      type: Function,
    },
    updateMode: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  async created() {
    this.openBankingSupported = this.obkCredsSupported && (await featureFlag.getTreatment(`${this.source.id}_open_banking`)) === 'on';
  },
  data() {
    return {
      openBankingSupported: false,
    };
  },
  computed: {
    obkCredsSupported() {
      return this.source.openBanking;
    },
    nonObkCredsSupported() {
      return this.source.credentials;
    },
    showOpenBankingLogo() {
      return !this.source.credentials;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../node_modules/base-ui/src/scss/riseup-colors';
@import '../../../scss/mixins';

.source-connection-details {
  background-color: $riseup_white;
  .title {
    color: $riseup_black;
    font-size: 18px;
    line-height: 1.44;
    margin-bottom: 20px;

    .bold {
      font-weight: bold;
      margin-bottom: 10px;
    }
  }

  .separator {
    @include responsive-padding;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    color: $riseup_gray_2;

    .line {
      height: 1px;
      width: 100%;
      background-color: $riseup_gray_1;
    }

    .or {
      font-family: SimplerPro;
      color: $riseup_black;
      margin: 0 15px;
    }
  }
}
</style>
